// https://www.totaltypescript.com/tips/create-autocomplete-helper-which-allows-for-arbitrary-values

/**
 * useful for cases when return type is a string, but we want to narrow it down in a way
 * that it stays a string but we have the intellisense
 * please refer to the article
 */
export type LooseAutocomplete<T extends string> = T | Omit<string, T>;
